import config from '@/config';

export default {
  methods: {
    apiErrorCallback(err) {
      this.$notifications.clear();
      console.warn(err);
      if (err && !err.response) {
        // network error
        this.$notify({
          title: this.$t('common.messages.network_error'),
          type: 'warning',
        });
        return;
      }
      if (err && err.response && err.response.data && err.response.data.body
        && (err.response.data.body === 'trello_not_authorized'
          || err.response.data.body === 'invalid'
          || err.response.data.body === 'invalid token')
      ) {
        window.location = `${config.apiUrl.replace(
          /\/api\/?/,
          '/',
        )}trello/authorize?token=${this.$store.state.token}`;
        return;
      }

      let message;
      if (this.$te(`common.messages.${this.parseErrorResponse(err.response || err.data || err)}`)) {
        message = this.$t(`common.messages.${this.parseErrorResponse(err.response)}`);
      } else {
        message = this.parseErrorResponse(err.response || err.data || err);
      }
      this.$notify({
        title: message,
        type: 'warning',
      });
    },
    parseErrorResponse(err) {
      if (!err) {
        return '';
      }
      if (err.data) {
        if (err.data.message) {
          return err.data.message;
        } if (err.data.errors) {
          if (err.data.errors[0] && err.data.errors[0].message) {
            return err.data.errors[0].message;
          }
          return JSON.stringify(err.data.errors);
        }
        return err.data instanceof String ? err.data : JSON.stringify(err.data);
      }
      return `Error status: ${err.status}`;
    },
  },
};
